import { render, staticRenderFns } from "./TrxP_List.vue?vue&type=template&id=be1b6228"
import script from "./TrxP_List.vue?vue&type=script&lang=js"
export * from "./TrxP_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports